<mc-loading [overlay]="true" *ngIf="loading"></mc-loading>
<div class="ig-container p-0">
    <!-- Connect IG -->
    <div
        *ngIf="!instagramResponse?.loggedIn"
        class="container-box mt-4 d-flex flex-wrap justify-content-center justify-content-lg-start"
    >
        <instagram-empty-state (login)="login()"></instagram-empty-state>
    </div>
    <!-- Connect IG -->

    <!-- IG data -->
    <div
        *ngIf="instagramResponse?.loggedIn && !loading"
        class="d-flex align-items-center justify-content-between col-12 px-2"
    >
        <div class="p-0 d-flex align-items-center justify-content-between col-11">
            <p class="design-modal-title mb-0 mr-2" *ngIf="!instagramAccountData">
                {{ 'app.global.modals.image_manager.upload_image_modal.instagram.account' | translate }}
            </p>
            <p class="design-modal-title mb-0 mr-2" *ngIf="instagramAccountData && !loading">
                {{ 'app.global.modals.image_manager.upload_image_modal.instagram.account_data' | translate }}
                <span class="font-weight-bold" ngbTooltip="{{ instagramAccountData.username_id }}"
                    >'{{ instagramAccountData.username }}'</span
                >
            </p>
            <i class="fa-light fa-arrow-right-from-bracket icon-logout" (click)="logout()"></i>
        </div>
    </div>
    <!-- IG data -->

    <!-- Imgs -->
    <div
        *ngIf="instagramResponse?.loggedIn"
        class="container-box pt-4 d-flex flex-wrap justify-content-center justify-content-lg-start"
        (scroll)="onScroll($event)"
    >
        <ng-container *ngFor="let photo of instagramPhotos; let i = index">
            <div class="img-container position-relative mr-3 mb-3" (click)="toggleFileSelection(photo)">
                <img class="w-100" src="{{ getImageUrl(photo) }}" alt="" />
                <!-- <p class="description pr-3 pr-sm-2">{{photo?.caption}}</p> -->
                <!-- <i class="fa-light fa-magnifying-glass"></i> -->
                <input [checked]="selectedFiles.has(photo)" type="checkbox" />
                <div class="buttons-container d-flex flex-wrap justify-content-end">
                    <i
                        class="fa-light fa-magnifying-glass"
                        (click)="openCarouselModal(i); $event.stopPropagation()"
                    ></i>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- Imgs -->

    <div *ngIf="instagramPhotos?.length" class="d-flex justify-content-between justify-content-sm-end mt-3 mt-lg-4">
        <button class="btn btn-skip mr-0 mr-sm-4" tabindex="0" (click)="reset()">
            {{ 'app.global.modals.image_manager.upload_image_modal.instagram.buttons.cancel' | translate }}
        </button>
        <button
            class="btn btn-continue"
            type="submit"
            tabindex="0"
            (click)="upload()"
            [disabled]="!selectedFiles.size || loading"
        >
            <!-- <mc-loading *ngIf="loading" color="text-white" size="sm"></mc-loading> -->
            <mc-loading [overlay]="true" *ngIf="loading" color="text-white" size="sm"></mc-loading>
            {{ 'app.global.modals.image_manager.upload_image_modal.instagram.buttons.add' | translate }}
        </button>
    </div>
</div>
